export const SET_LOADING_DATA = '@productList/SET_LOADING_DATA';

export const GET_LIST_PRODUCT_REQUEST = '@productList/GET_LIST_PRODUCT_REQUEST';
export const GET_LIST_PRODUCT_SUCCESS = '@productList/GET_LIST_PRODUCT_SUCCESS';

export const SET_PAGE = '@productList/SET_PAGE';
export const SET_ROWS_COUNT = '@productList/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@productList/SET_ROWS_PER_PAGE';
export const SET_ROWS_ORIENTATION = '@productList/SET_ROWS_ORIENTATION';
export const SET_ORDER = '@productList/SET_ORDER';
export const SET_ORDERBY = '@productList/SET_ORDERBY';

export const SET_SWITCHES_FILTERS = '@productList/SET_SWITCHES_FILTERS';

export const SEARCH = '@productList/SEARCH';
